import styled from '@emotion/styled';
import { theme as aulaTheme } from '@ublend-npm/aulaui-next';

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  margin-top: ${aulaTheme.spacing.small};
`;
